import React, { useState } from 'react';
import { BlogCard } from '../components/ui/Cards';
import { blogPosts } from '../data';
import './ListPage.css';

const categories = [
  { key: 'all', label: 'All Posts' },
  { key: 'travel-tips', label: 'Travel Tips' },
  { key: 'morocco-guides', label: 'Morocco Guides' },
  { key: 'city-guides', label: 'City Guides' },
  { key: 'desert-tours', label: 'Desert Tours' },
  { key: 'cultural-experiences', label: 'Cultural' },
  { key: 'food-guides', label: 'Food Guides' },
];

export default function Blog() {
  const [cat, setCat] = useState('all');

  const filtered = cat === 'all' ? blogPosts : blogPosts.filter(p => p.category === cat);

  return (
    <>
      <div className="page-hero">
        <div className="container">
          <div className="section-tag">Travel Inspiration</div>
          <h1>Morocco Travel Guide</h1>
          <p>Expert tips, destination guides, and travel inspiration for your Morocco trip</p>
        </div>
      </div>

      <section className="section section-white">
        <div className="container">
          <div className="list-controls" style={{ marginBottom: 32 }}>
            <div className="list-tabs" style={{ flexWrap: 'wrap' }}>
              {categories.map(c => (
                <button
                  key={c.key}
                  className={`list-tab${cat === c.key ? ' active' : ''}`}
                  onClick={() => setCat(c.key)}
                >{c.label}</button>
              ))}
            </div>
          </div>
          <div className="grid-3">
            {filtered.map(p => <BlogCard key={p.id} post={p} />)}
          </div>
          {filtered.length === 0 && (
            <p style={{ textAlign: 'center', color: 'var(--muted)', padding: '40px 0' }}>
              No posts in this category yet. Check back soon!
            </p>
          )}
        </div>
      </section>
    </>
  );
}
